export interface LivenessRuntimeConfig {
  readonly stage: string;
  readonly apiBaseUrl: string;
  readonly region: string;
  readonly identityPoolId: string;
  readonly webhookSecret: string;
}

export function getRuntimeConfig(): LivenessRuntimeConfig {
  const runtime = window.__CRIME_LIVENESS_RUNTIME_CONFIG__;
  return {
    stage: runtime?.stage || process.env.REACT_APP_STAGE || 'sandbox',
    apiBaseUrl: runtime?.apiBaseUrl || process.env.REACT_APP_API_BASE_URL || '',
    region: runtime?.region || process.env.REACT_APP_AWS_REGION || 'eu-north-1',
    identityPoolId: runtime?.identityPoolId || process.env.REACT_APP_LIVENESS_IDENTITY_POOL_ID || '',
    webhookSecret: runtime?.webhookSecret || process.env.REACT_APP_LIVENESS_WEBHOOK_SECRET || '',
  };
}
